import {useState, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
    makeBuyOrder,
    makeSellOrder
} from "../store/interactions";

import config from "../config.json";

import { FaTwitter, FaGithub, FaLink, FaBook } from 'react-icons/fa';


const Order = ()=>{
    const [isBuy, setisBuy] = useState(true);
    const [amount, setAmount] = useState(0);
    const [price, setPrice] = useState(0);

    const buyRef = useRef(null);
    const sellRef = useRef(null);

    const dispatch = useDispatch();

    const provider = useSelector(state => state.provider.connection);
    const tokens = useSelector(state => state.tokens.contracts);
    const exchange = useSelector(state => state.exchange.contract);

    const tokenBalances = useSelector(state => state.tokens.balances);
    const exchangeBalances = useSelector(state => state.exchange.balances);

    const symbols = useSelector(state => state.tokens.symbols);
    const chainId = useSelector(state => state.provider.chainId);

    const tabHandler = (e)=>{
        if(e.target.className !== buyRef.current.className){
            buyRef.current.className = 'tab';
            setisBuy(false);
        }else{
            sellRef.current.className= 'tab';
            setisBuy(true);
        }

        e.target.className='tab tab--active';
    }

    const buyHandler =(e)=>{
        e.preventDefault();
        if( provider && dispatch && tokens && exchange) makeBuyOrder(dispatch,provider,tokens,{amount,price},exchange);
        setAmount(0);
        setPrice(0);

    }
    // const buyHandler =(e)=>{
    //     e.preventDefault();
    //     if( provider && dispatch && tokens && exchange) {
    //         makeBuyOrder(dispatch,provider,tokens,{amount,price},exchange)
    //             .then((success) => {
    //                 if (success) {
    //                     setAmount(0);
    //                     setPrice(0);
    //                 }
    //             });
    //     }
    // }

    const sellHandler= (e)=>{
        e.preventDefault();
        if( provider && dispatch && tokens && exchange) makeSellOrder(dispatch,provider,tokens,{amount,price},exchange);
        setAmount(0);
        setPrice(0);
    }
    // const sellHandler= (e)=>{
    //     e.preventDefault();
    //     if( provider && dispatch && tokens && exchange) {
    //         makeSellOrder(dispatch,provider,tokens,{amount,price},exchange)
    //             .then((success) => {
    //                 if (success) {
    //                     setAmount(0);
    //                     setPrice(0);
    //                 }
    //             });
    //     }
    // }

    return(
        <div className="component exchange__orders" >
            <div className="component__header flex-between">
                {/* <h2> New Order</h2> */}
                <a href="https://open-dex.gitbook.io/docs-willow/quick-start#id-3.-open-order-if-open-order" target='_blank' class="hover:text-sky-500 transition-colors duration-300 ease-in-out  ">
                <h2 title="How to (calcurate)"> Open Order</h2></a>
{/* <a href="https://pancakeswap.finance/swap?chain=sepolia&outputCurrency=0xfFf9976782d46CC05630D1f6eBAb18b2324d6B14&inputCurrency=SEP" target='_blank' class="hover:text-sky-500 transition-colors duration-300 ease-in-out  ">
  <svg  xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
    <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"/>
    <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"/>
  </svg>
</a> */}

                <div className="tabs">
                    <button onClick={tabHandler} ref={buyRef} className="tab tab--active">Buy</button>
                    <button onClick={tabHandler} ref={sellRef} className="tab">Sell</button>
                </div>
            </div>

            <form onSubmit={isBuy? buyHandler : sellHandler}>
                {
                    isBuy?(
                        <label htmlFor='amount' className="flex items-center">
                 {/* Buy             */}
      &nbsp;<img 
                src={config && chainId && symbols && symbols[0] && config[chainId][symbols[0]] ? config[chainId][symbols[0]]['image'] : ''} 
                className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
                alt="TokenLogo"
            /> :           
      &nbsp;<img 
                src={config && chainId && symbols && symbols[1] && config[chainId][symbols[1]] ? config[chainId][symbols[1]]['image'] : ''} 
                className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
                alt="TokenLogo"
            /> Amount (Trade) </label>
                    ):(
                        <label htmlFor='amount' className="flex items-center">
                 {/* Sell */}
      &nbsp;<img 
                src={config && chainId && symbols && symbols[0] && config[chainId][symbols[0]] ? config[chainId][symbols[0]]['image'] : ''} 
                className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
                alt="TokenLogo"
            /> Amount (Trade) <small className="ml-2">Deposit ({symbols[0]}): {exchangeBalances && Number(exchangeBalances[0]).toFixed(3)}</small></label>
                    )
                }

                <input 
                type="text" 
                id='amount' 
                placeholder="0.000" 
                maxlength="5" //
                value ={ amount ===0?'':amount}
                onChange={(e)=> setAmount(e.target.value)}
                />

                {
                    isBuy?(
                        <label htmlFor='amount' className="flex items-center">
                 {/* Buy              */}

        &nbsp;<img 
            src={config && chainId && symbols && symbols[1] && config[chainId][symbols[1]] ? config[chainId][symbols[1]]['image'] : ''} 
            className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
            alt="TokenLogo"
        /> Price (Pairs) <small className="ml-2">Deposit ({symbols[1]}): {exchangeBalances && Number(exchangeBalances[1]).toFixed(3)}</small></label>
                    ):(
                        <label htmlFor='amount' className="flex items-center">
                 {/* Sell  */}
        &nbsp;<img 
                src={config && chainId && symbols && symbols[0] && config[chainId][symbols[0]] ? config[chainId][symbols[0]]['image'] : ''} 
                className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
                alt="TokenLogo"
            /> : 
        &nbsp;<img 
            src={config && chainId && symbols && symbols[1] && config[chainId][symbols[1]] ? config[chainId][symbols[1]]['image'] : ''} 
            className="max-w-8 max-h-6 mr-2" // Tailwind CSS classes to set the maximum width and height and margin right
            alt="TokenLogo"
        /> Price (Pairs)</label>
                    )
                }

                <input 
                type="text" 
                id='price' 
                placeholder="0.000" 
                maxlength="5" //
                value ={ price ===0?'':price}
                onChange={(e)=> setPrice(e.target.value)}
                />


{/* Calculation display for Buy */}
{(amount > 0 && price > 0 && isBuy) && (
    <div className="mt-2 p-2 border border-gray-300 rounded-md text-center">
        {/* Calculate the rate */}
        {/* Buy rate:  */}
        1 {symbols[0]} = {price >= amount ? (amount * price).toFixed(4) : (price / amount * amount).toFixed(4)} {symbols[1]}
        <br />
        <small className="ml-2">Token to spend: <b>{(parseFloat(amount) * price).toFixed(4)}</b> {symbols[1]}</small>
        <br />
        <br />
        Total will receive: {(amount * price / price).toFixed(4)} <img src={config[chainId][symbols[0]]['image']} alt={symbols[0]} className="max-w-4 max-h-4  inline-block"/>
    </div>
)}

{/* Calculation display for Sell */}
{(amount > 0 && price > 0 && !isBuy) && (
    <div className="mt-2 p-2 border border-gray-300 rounded-md text-center">
        {/* Calculate the rate */}
        {/* Sell rate:  */}
        1 {symbols[0]} = {(price / amount * amount).toFixed(4)} {symbols[1]}
        <br />
        <small className="ml-2">Token to spend: <b>{parseFloat(amount).toFixed(4)}</b> {symbols[0]}</small>
        <br />
        <br />
        Total will receive: {(amount * price).toFixed(4)}  <img src={config[chainId][symbols[1]]['image']} alt={symbols[1]} className="max-w-4 max-h-4  inline-block"/>
    </div>
)}


                <button className="button button--filled" type="submit">
                    {
                        isBuy?(
                            // <span className='text-green-500 animate-pulse'>Buy Order</span>
                            <span className='text-green-500 '>Buy Order</span>
                        ):(
                            <span className='text-red-500 '>Sell Order</span>
                        )
                    }
                </button>
            </form>

            
            {/* Footer ที่ปรับให้อยู่กึ่งกลาง */}
            <footer className="footer flex flex-col items-center">
                <div className="footer-icons flex mb-4">
                    <a href="https://open-dex.gitbook.io/docs-willow" target="_blank" rel="noopener noreferrer" className="hover:text-sky-500 transition-colors duration-300 ease-in-out"><FaBook /></a>
                    &nbsp;
                    <a href="https://twitter.com/willow_opendex" target="_blank" rel="noopener noreferrer" className="hover:text-sky-500 transition-colors duration-300 ease-in-out"><FaTwitter /></a>
                    &nbsp;
                    {/* <a href="https://github.com/your_github_username" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
                    &nbsp; */}
                    <a href="https://linktr.ee/willow_opendex" target="_blank" rel="noopener noreferrer" className="hover:text-sky-500 transition-colors duration-300 ease-in-out"><FaLink /></a>
                </div>
                {/* <p>&copy; 2024 willow. All rights reserved.</p> */}
                <p>&copy; 2024 willow. All rights reserved.</p>
                {/* <br></br> */}
            </footer>

        </div>        
    );
}

export default Order;